import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { ButtonComponent, CheckboxComponent, OptionToggleComponent } from '@hs/ui-core-inputs';

export interface ExcelExportChoices {
    type: 'CSV' | 'EXCEL';
    filtered: boolean;
    excludeCrosstalkKeys?: boolean;
    widgetIds: (string | number)[];
}

@Component({
    selector: 'ddv-dashboard-export-form',
    templateUrl: './dashboard-export-form.component.html',
    styleUrls: ['./dashboard-export-form.component.scss'],
    imports: [
        ButtonComponent,
        OptionToggleComponent,
        CheckboxComponent,
    ],
})
export class DashboardExportFormComponent implements OnChanges {
    @Input() widgets: { name?: string, id?: string | number }[] | undefined;
    @Input() hasCrosstalkData = false;

    @Output() exportPDF = new EventEmitter<void>();
    @Output() exportExcel = new EventEmitter<ExcelExportChoices>();

    protected filteredExport = true;
    protected excludeCrosstalkKeys = true;
    protected widgetOptions: SelectableWidget[] = [];
    protected allWidgetsSelected: boolean | undefined = false;
    protected hasNoSelectedWidgets = true;

    ngOnChanges(): void {
        this.widgetOptions = this.widgets?.map((widget) => {
            return {
                name: widget.name ?? '',
                id: widget.id?.toString() ?? '',
                selected: false,
            };
        }) ?? [];
    }

    protected emitExcelExport(type: 'CSV' | 'EXCEL'): void {
        const choices: ExcelExportChoices = {
            type,
            filtered: this.filteredExport,
            widgetIds: this.widgetOptions
                .filter((widget) => widget.selected)
                .map((widget) => widget.id),
        };

        if (this.hasCrosstalkData) {
            choices.excludeCrosstalkKeys = this.excludeCrosstalkKeys;
        }

        this.exportExcel.emit(choices);
    }

    protected onSelectAllToggled(selected: boolean): void {
        this.widgetOptions = this.widgetOptions.map((wo) => {
            return {
                ...wo,
                selected,
            };
        });

        this.enableSelectionRelatedComponents();
    }

    protected onToggleWidget(id: string, selected: boolean): void {
        this.widgetOptions = this.widgetOptions.map((wo) => {
            const updated = { ...wo };
            if (wo.id === id) {
                wo.selected = selected;
            }
            return updated;
        });

        this.enableSelectionRelatedComponents();
    }

    private enableSelectionRelatedComponents(): void {
        if (this.widgetOptions.every((wo) => wo.selected)) {
            this.allWidgetsSelected = true;
            this.hasNoSelectedWidgets = false;
        } else if (this.widgetOptions.every((wo) => !wo.selected)) {
            this.allWidgetsSelected = false;
            this.hasNoSelectedWidgets = true;
        } else {
            this.allWidgetsSelected = undefined;
            this.hasNoSelectedWidgets = false;
        }
    }
}

interface SelectableWidget {
    name: string;
    id: string;
    selected: boolean;
}
